import { infer as Infer, z } from 'zod';

import { coordinatesRegex } from '#utils/coordinates.regex';

export const locationCreateSchema = z.object({
  name: z.string('Nazwa jest wymagana').min(2, 'Nazwa jest zbyt krótka (min 2 znaki)').max(20, 'Nazwa jest zbyt długa (max 20 znaków)').trim(),
  desc: z.string().max(100, 'Opis jest zbyt długi (max 100 znaków)').nullable(),
  address: z.string().nullable(),
  coordinates: z.string('Współrzędne są wymagane').min(1, 'Współrzędne są wymagane').regex(coordinatesRegex, 'Niepoprawne współrzędne'),
});

export const locationSchema = locationCreateSchema.extend({
  id: z.number(),
});

export type LocationCreateSchema = Infer<typeof locationCreateSchema>;
export type LocationSchema = Infer<typeof locationSchema>;
